'use strict';var _desc,_value,_class;function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key]});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=!0}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=void 0}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null}return desc}

const _=require('pulsar-utils/dist-es6/_');
const Formatters=require('../../../../dist-es6/client/formatters');
const ThresholdStatus=require('pulsar-dashboard-core/dist-es6/domain/thresholdStatus');
const NotificationType=require('pulsar-dashboard-core/dist-es6/domain/notificationType');
const BaseRealtimeUpdateController=require('../../../../dist-es6/client/angularCommon/baseRealtimeUpdateController');
const{UpdateFailedError}=BaseRealtimeUpdateController;
const{SocketTimeoutError,UnexpectedError}=require('../../../../dist-es6/client/services/socketService');
const ControllerExtensions=require('../../../../dist-es6/client/extensions/controllerExtensions');
const HandleUncaughtErrors=require('../../../../dist-es6/client/services/uncaughtErrorHandler').Annotations.HandleUncaughtErrors;
const timespan=require('pulsar-utils/dist-es6/time/timespan');
const FatigueMeterType=require('pulsar-utils/dist-es6/domain/fatigueMeterType');let

DashboardController=(_class=class DashboardController extends BaseRealtimeUpdateController{
constructor(
$scope,
$state,
$timeout,
$interval,
dateService,
breadcrumbsService,
dashboardDataService,
userService,
Analytics,
uncaughtErrorHandler,
groupTreeService,
fatigueMeterTypeContentProviderService,
timeZoneService,
paramSyncService)
{
super(uncaughtErrorHandler,$scope,$timeout,$interval,dateService,timespan.fromMinutes(5),timespan.fromSeconds(1),timeZoneService);

this._$timeout=$timeout;
this._$state=$state;

this._uncaughtErrorHandler=uncaughtErrorHandler;
this._dashboardDataService=dashboardDataService;
this._userService=userService;
this._analytics=Analytics;

this.sortByFatigueAlertType=this._sortByFatigueAlertType.bind(this);
this.searchQuery='';

this._groupTreeService=groupTreeService;
this._fatigueMeterTypeContentProviderService=fatigueMeterTypeContentProviderService;
this._paramSyncService=paramSyncService;
this._selectedNotificationType=NotificationType.AllThresholdsExceeded;

this.subViewConfiguration=this._getSubViewConfiguration();

breadcrumbsService.startTrail('Dashboard');

groupTreeService.linkController(this);

this._updateUrlParamsFromController=paramSyncService.start(this,$scope,newParams=>this._updateControllerParamsFromUrl(newParams));

this._beginUpdates();
}

_updateControllerParamsFromUrl(newStateParams){
const{groupId}=newStateParams;

if(_.get(this.selectedGroup,'id')===groupId){
return;
}

this._groupTreeService.selectGroupWithId(groupId);
}

get groupTreeService(){
return this._groupTreeService;
}

set groupTreeService(groupTreeService){
this._groupTreeService=groupTreeService;
}

get $scope(){
return this._$scope;
}

get $state(){
return this._$state;
}

get stateName(){
return'fdc.features.dashboard';
}

get dataService(){
return this._dashboardDataService;
}


async _update(){
try{
await this._dashboardDataService.update();
}catch(err){
if(err instanceof SocketTimeoutError||err instanceof UnexpectedError){
throw new UpdateFailedError;
}
throw err;
}
}

get _lastFetchTime(){
return this._dashboardDataService.lastFetchTime;
}

get _isUpdating(){
return this._dashboardDataService.isUpdating;
}

get groupTree(){
return this._dashboardDataService.groupTree;
}

get estimatesAsOfTime(){
return this._dashboardDataService.estimatesAsOfTime;
}

get selectedGroup(){
return this._groupTreeService.selectedGroup;
}

get selectedGroupData(){
return this._dashboardDataService.selectedGroupData;
}

get selectedNotificationType(){
return this._selectedNotificationType;
}

sortByFatigueScore(item){
return Math.floor(item.fatigueAlertScore)||Number.NEGATIVE_INFINITY;
}

_sortByFatigueAlertType(personViewModel){
let thresholdStatus=personViewModel.thresholdStatusFor(this.selectedNotificationType);

switch(thresholdStatus){
case ThresholdStatus.Above:
return 2;
case ThresholdStatus.At:
return 1;
default:
return Number.NEGATIVE_INFINITY;}

}

get dashboardDataService(){
return this._dashboardDataService;
}

_getSubViewConfiguration(){
let propsToBindToSubViews=[
'dashboardDataService',
'searchQuery',
'filteredPersons',
'sortByFatigueScore',
'sortByFatigueAlertType',
'groupTree',
'selectedGroup',
'selectedGroupData',
'selectedNotificationType'];


return ControllerExtensions(this).getMultiViewConfigurationFor(propsToBindToSubViews,[{
label:'List',
directiveName:'pulsar-dashboard-list'},
{
label:this._fatigueMeterTypeContentProviderService.heatmapButtonLabel,
directiveName:'pulsar-dashboard-heatmap'}]);

}},(_applyDecoratedDescriptor(_class.prototype,'_update',[HandleUncaughtErrors],Object.getOwnPropertyDescriptor(_class.prototype,'_update'),_class.prototype)),_class);


module.exports=DashboardController;
//# sourceMappingURL=dashboardController.js.map
